import * as React from 'react';
import Link from "gatsby-link";


export const NavItem = ({text,to ,setMenuOpen, path="" , style}) => {
  const noHash = path.split('#')[0].replace(/\//g , '');
    const active = noHash===to.replace(/\//g , '') ? " active " : "";

  return (
    <li  style={style} className={"menu-item" +active}><Link onClick={()=>{setMenuOpen&&setMenuOpen(false)}} to={to}>{text}</Link></li>
  );
};
